export default __webpack_public_path__ + "static/media/templates.bf4febf4.svg";